import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { useTheme } from '../lib/ThemeContext';

const links = {
  solutions: [
    { name: 'AI & Cloud-Native', path: '/solutions' },
    { name: 'Cybersecurity', path: '/solutions' },
    { name: 'Infrastructure', path: '/solutions' },
    { name: 'Managed Services', path: '/managed-services' },
    { name: 'DevOps & Cloud Native', path: '/devops' },
  ],
  company: [
    { name: 'About DNS', path: '/company' },
    { name: 'Careers', path: '/careers' },
    { name: 'Partners', path: '/partners' },
    { name: 'Contact', path: '/contact' },
  ],
};

export default function Footer() {
  const { theme } = useTheme();
  return (
    <footer data-testid="footer" className="border-t border-border mt-auto">
      <div className="max-w-6xl mx-auto px-5 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="space-y-4">
            <img src={theme === 'dark' ? '/images/dns-logo-white.png' : '/images/dns-logo.png'} alt="DNS" className="h-10 w-auto" />
            <p className="text-[13px] text-muted-foreground leading-relaxed max-w-[260px]">
              Nepal's premier System Integrator. Engineering enterprise IT infrastructure with ISO-certified precision.
            </p>
          </div>
          <div>
            <h4 className="text-[13px] font-semibold mb-4">Solutions</h4>
            <ul className="space-y-2.5">
              {links.solutions.map((l) => (<li key={l.name}><Link to={l.path} className="text-[13px] text-muted-foreground hover:text-foreground transition-colors">{l.name}</Link></li>))}
            </ul>
          </div>
          <div>
            <h4 className="text-[13px] font-semibold mb-4">Company</h4>
            <ul className="space-y-2.5">
              {links.company.map((l) => (<li key={l.name}><Link to={l.path} className="text-[13px] text-muted-foreground hover:text-foreground transition-colors">{l.name}</Link></li>))}
            </ul>
          </div>
          <div>
            <h4 className="text-[13px] font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2"><MapPin className="w-3.5 h-3.5 text-muted-foreground mt-0.5 flex-shrink-0" /><span className="text-[13px] text-muted-foreground">Manakamana Marg, Naxal Nagpokhari, Kathmandu</span></li>
              <li className="flex items-center gap-2"><Phone className="w-3.5 h-3.5 text-muted-foreground flex-shrink-0" /><a href="tel:+977-14537311" className="text-[13px] text-muted-foreground hover:text-foreground transition-colors">+977-14537311</a></li>
              <li className="flex items-center gap-2"><Mail className="w-3.5 h-3.5 text-muted-foreground flex-shrink-0" /><a href="mailto:mailus@digitalnetwork.com.np" className="text-[13px] text-muted-foreground hover:text-foreground transition-colors">mailus@digitalnetwork.com.np</a></li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[11px] text-muted-foreground">&copy; {new Date().getFullYear()} Digital Network Solution Pvt. Ltd.</p>
          <div className="flex items-center gap-4">
            <span className="font-mono text-[10px] text-muted-foreground">ISO 9001:2015</span>
            <span className="text-border">|</span>
            <span className="font-mono text-[10px] text-muted-foreground">ISO 27001</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
